import { useState } from 'react';

const stories = [
  {
    id: 1,
    name: '김민준 씨',
    age: '34세 · 척수장애 1급',
    location: '서울 노원구',
    thumbnail: 'https://public.readdy.ai/ai/img_res/b521e7e95114d153b2a855c37437006c.jpg',
    quote: '"활동지원사 선생님 덕분에 매일 밖으로 나갈 수 있게 됐어요. 세상이 이렇게 넓은지 몰랐어요."',
    duration: '12:34',
  },
  {
    id: 2,
    name: '이수진 씨',
    age: '28세 · 뇌병변장애 2급',
    location: '경기 수원시',
    thumbnail: 'https://readdy.ai/api/search-image?query=young%20Korean%20woman%20with%20cerebral%20palsy%20disability%20doing%20everyday%20activities%20at%20home%20with%20caregiver%2C%20warm%20soft%20light%2C%20caring%20supportive%20atmosphere%2C%20Korean%20home%20setting%2C%20documentary%20warmth&width=640&height=400&seq=story002&orientation=landscape',
    quote: '"제 꿈을 포기하지 않도록 응원해주는 사람들이 곁에 있어 행복해요."',
    duration: '09:21',
  },
  {
    id: 3,
    name: '박성호 씨',
    age: '52세 · 지체장애 3급',
    location: '부산 해운대구',
    thumbnail: 'https://readdy.ai/api/search-image?query=middle%20aged%20Korean%20man%20with%20physical%20disability%20enjoying%20outdoor%20activity%20with%20caregiver%20helper%2C%20sunny%20park%20scene%20in%20Korea%2C%20warm%20golden%20light%2C%20joyful%20and%20empowering%20atmosphere%2C%20natural%20photography&width=640&height=400&seq=story003&orientation=landscape',
    quote: '"혼자서는 할 수 없었던 일들을 이제는 하나씩 해나가고 있어요. 삶이 달라졌습니다."',
    duration: '15:08',
  },
];

export default function VideoSection() {
  const [playing, setPlaying] = useState<number | null>(null);
  const [activeStory, setActiveStory] = useState(stories[0]);

  return (
    <section id="stories" className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-rose-50 text-rose-700 rounded-full px-4 py-1.5 text-sm font-semibold mb-4">
            <i className="ri-video-line text-rose-500"></i>
            REAL STORIES
          </div>
          <h2 className="text-5xl font-bold text-stone-800 mb-4">
            장애인들의 <span className="text-rose-500">진솔한 이야기</span>
          </h2>
          <p className="text-stone-500 text-lg max-w-xl mx-auto">
            일상 속 작은 변화들이 모여 큰 희망이 됩니다.<br />
            그들의 이야기를 직접 들어보세요.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="relative rounded-3xl overflow-hidden aspect-video group cursor-pointer" onClick={() => setPlaying(activeStory.id)}>
            <img
              src={activeStory.thumbnail}
              alt={activeStory.name}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-stone-900/40 group-hover:bg-stone-900/50 transition-colors"></div>
            <div className="absolute inset-0 flex items-center justify-center">
              {playing === activeStory.id ? (
                <div className="w-20 h-20 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full border-2 border-white cursor-pointer">
                  <i className="ri-pause-fill text-white text-4xl"></i>
                </div>
              ) : (
                <div className="w-20 h-20 flex items-center justify-center bg-white rounded-full shadow-xl cursor-pointer group-hover:scale-110 transition-transform">
                  <i className="ri-play-fill text-stone-800 text-3xl ml-1"></i>
                </div>
              )}
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-stone-900/80 to-transparent">
              <p className="text-white font-bold text-lg">{activeStory.name}</p>
              <p className="text-white/70 text-sm">{activeStory.age} · {activeStory.location}</p>
              <div className="flex items-center gap-2 mt-2">
                <div className="w-4 h-4 flex items-center justify-center bg-white/20 rounded-full">
                  <i className="ri-time-line text-white text-xs"></i>
                </div>
                <span className="text-white/60 text-xs">{activeStory.duration}</span>
              </div>
            </div>
          </div>

          <div>
            <blockquote className="text-2xl font-medium text-stone-700 leading-relaxed italic mb-10 border-l-4 border-amber-500 pl-6">
              {activeStory.quote}
            </blockquote>
            <div className="space-y-4">
              {stories.map((story) => (
                <button
                  key={story.id}
                  onClick={() => { setActiveStory(story); setPlaying(null); }}
                  className={`w-full flex items-center gap-4 p-4 rounded-2xl border transition-all cursor-pointer text-left ${
                    activeStory.id === story.id
                      ? 'border-amber-400 bg-amber-50'
                      : 'border-stone-200 bg-white hover:border-stone-300'
                  }`}
                >
                  <div className="w-16 h-16 flex-shrink-0 rounded-xl overflow-hidden">
                    <img src={story.thumbnail} alt={story.name} className="w-full h-full object-cover" />
                  </div>
                  <div className="flex-1">
                    <p className="font-semibold text-stone-800 text-sm">{story.name}</p>
                    <p className="text-stone-500 text-xs mt-0.5">{story.age}</p>
                    <p className="text-stone-400 text-xs mt-1">{story.location}</p>
                  </div>
                  <div className={`w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0 ${
                    activeStory.id === story.id ? 'bg-amber-500' : 'bg-stone-100'
                  }`}>
                    <i className={`ri-play-fill text-sm ${activeStory.id === story.id ? 'text-white' : 'text-stone-400'}`}></i>
                  </div>
                </button>
              ))}
            </div>

            <div className="mt-8 p-5 bg-stone-50 rounded-2xl border border-stone-200">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-amber-100 rounded-lg flex-shrink-0">
                  <i className="ri-information-line text-amber-600 text-sm"></i>
                </div>
                <p className="text-stone-600 text-sm leading-relaxed">
                  모든 영상은 당사자의 동의를 받아 제작되었습니다. 더 많은 이야기를 공유하고 싶으신 분들은
                  <span className="text-amber-700 font-medium"> 참여 신청</span>을 통해 연락해 주세요.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
